import React from 'react';
import { formatBlocks, learnOutputs } from '../../data/ferringConcept';
export function FormatPanel() {
  return <div data-id="element-65" data-mp="gaengn1hkg4d">
      <h2 className="text-[36px] font-medium leading-[1.04] tracking-[-0.035em] text-navy md:text-[48px]" data-id="element-66" data-mp="gaobw66vuf7y">What the Snakker format adds</h2>
      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-5 lg:gap-0" data-id="element-67" data-mp="bc3cua3da1l3">
        {formatBlocks.map((b, i) => <article key={b.title} className={`lg:px-5 ${i === 0 ? 'lg:pl-0' : 'lg:border-l lg:border-navy/10'}`} data-id="element-68" data-mp="1budwohzq220" data-mpi={i}>
            <h3 className="text-xl font-medium tracking-[-0.02em] text-navy" data-id="element-69" data-mp="3sqi623ghnxv0">{b.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-navy/60" data-id="element-70" data-mp="3oon8na1oi4mi">{b.body}</p>
          </article>)}
      </div>

      <div className="mt-12 border-t border-navy/10 pt-10" data-id="element-71" data-mp="3jr4yxhfu7ldg">
        <h3 className="text-2xl font-medium tracking-[-0.02em] text-navy" data-id="element-72" data-mp="3eqpkemjtk7tw">Engagement creates insight</h3>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-navy/65" data-id="element-73" data-mp="39s5z8od1v02l">
          The primary job is a short, useful HCP interaction. Because the HCP actively participates, it also generates useful signals. In
          this illustrative example we could learn:
        </p>
        <ul className="mt-5 flex flex-wrap gap-2" data-id="element-74" data-mp="17ntb02auje25">
          {learnOutputs.map(o => <li key={o} className="rounded-full border border-navy/15 px-4 py-2 text-sm text-navy/80" data-id="element-75" data-mp="suzjtjm7p9hn">
              {o}
            </li>)}
        </ul>
        <p className="mt-6 text-lg font-medium text-navy" data-id="element-76" data-mp="1ln2p8wfhry3h">Every interaction creates a signal.</p>
      </div>
    </div>;
}